module.exports = __webpack_public_path__ + "img/23.ec4fe790.jpg";